import Icon from "patient-ping-remedy/packages/icon";
import {colors} from "patient-ping-remedy/packages/theme";
import styled from "@emotion/styled";
import {css, PropsOf} from "@emotion/react";

type Props = PropsOf<typeof Icon> & {
  hoverColor: string;
}

export const StyledTooltipIcon = styled(
  ({ hoverColor: _, ...props }: Props) => <Icon {...props} />)(
  (props) => css`
    :hover {
      color: ${props.hoverColor ? props.hoverColor : colors.primary1};
    }
`);
